<script setup>
import TextInput from '@/Components/Input/TextInput.vue';
import { reactive } from 'vue';
import PrimaryButton from '@/Components/Button/PrimaryButton.vue';
import isCidr from 'is-cidr';
import ipRangeCheck from 'ip-range-check';
import Card from '@/Components/Card/Card.vue';
import isValidIP from '@/Common/IsValidIp.js';
import Alert from '@/Components/Alert.vue';
import { TOOL_CIDR_CALCULATOR, captureToolUsed } from '@/Common/Posthog.js';

const form = reactive({
  ip: '',
  cidr: ''
});

const state = reactive({
  ipAddress: '',
  cidr: '',
  valid: false,
  ipInRange: false
});

function submit() {
  state.ipAddress = form.ip;
  state.cidr = form.cidr;
  state.valid = Boolean(isValidIP(state.ipAddress) && isCidr(state.cidr));
  state.ipInCidr = state.valid && ipRangeCheck(state.ipAddress, state.cidr);

  if (state.valid) {
    captureToolUsed({
      tool: TOOL_CIDR_CALCULATOR,
      properties: { mode: 'ip_in_cidr' }
    });
  }
}
</script>

<template>
  <form
    class="flex grow flex-col gap-4 md:flex-row md:items-center"
    @submit.prevent
  >
    <TextInput
      v-model.trim="form.ip"
      size="large"
      :label="$t('cidr_calculator.partials.ip_address_form.ip_address')"
      description="e.g. 127.0.0.1"
      :placeholder="
        $t('cidr_calculator.partials.ip_address_form.enter_ip_address')
      "
      @input="state.valid = false"
    />
    <TextInput
      v-model.trim="form.cidr"
      size="large"
      label="CIDR"
      description="e.g. 127.0.0.1/15"
      :placeholder="$t('cidr_calculator.partials.ip_address_form.enter_cidr')"
      @input="state.valid = false"
    />
    <div class="flex items-center md:mt-2">
      <PrimaryButton size="large" @click="submit">
        {{ $t('cidr_calculator.partials.ip_address_form.check') }}
      </PrimaryButton>
    </div>
  </form>

  <Teleport v-if="state.valid" to="#results">
    <Card>
      <Alert
        v-if="state.ipInCidr"
        :title="$t('cidr_calculator.partials.ip_address_form.ip_address_found')"
        variant="success"
      >
        {{
          $t('cidr_calculator.partials.ip_address_form.success', {
            ip_address: state.ipAddress,
            cidr: state.cidr
          })
        }}
      </Alert>
      <Alert
        v-else
        :title="
          $t('cidr_calculator.partials.ip_address_form.ip_address_not_found')
        "
        variant="danger"
      >
        {{
          $t('cidr_calculator.partials.ip_address_form.danger', {
            ip_address: state.ipAddress,
            cidr: state.cidr
          })
        }}
      </Alert>
    </Card>
  </Teleport>
</template>
